import { WebVTTParser } from './parser.js'

import type { TrickImages } from './types'

export default async (track: string) => {
  let objectCues: TrickImages | null = null
  try {
    const vttData = await fetch(track)
      .then((response) => {
        return response.body
      })
      .then((rb: ReadableStream<Uint8Array> | null) => {
        if (rb === null) {
          return null
        }
        const reader = rb.getReader()
        return new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close()
                  return
                }
                controller.enqueue(value)
                push()
              })
            }
            push()
          },
        })
      })
      .then((stream) =>
        new Response(stream, {
          headers: { 'Content-Type': 'text/vtt' },
        }).text()
      )
    const parser = new WebVTTParser()
    const parsedData = parser.parse(
      vttData.replace('WEBVTT ', 'WEBVTT\n\n'),
      'metadata'
    )

    for (let i = 0; i < parsedData.cues.length; i++) {
      if (objectCues === null) {
        objectCues = {}
      }
      const cue = parsedData.cues[i]
      const startTimeSeconds = Math.round(cue.startTime)
      objectCues[startTimeSeconds] = cue
    }
  } catch (error) {
    console.error('Error parsing VTT file', error)
  }
  return objectCues
}
